/* ==========================================================================
   Make It Fabulous - product card swatch helper (skin only, no core edits)
   1. Preloads each card's variant images (same URL Minimog requests) when the
      card nears the viewport or is hovered, so a swatch click swaps instantly.
   2. Soft 0.3s fade when the card image changes after a swatch click.
   3. Keeps the chosen colour: Minimog resets cards to their first variant
      whenever any <responsive-image> fires "m:image-loaded".
   Loaded with defer from snippets/mif-font-faces.liquid.
   ========================================================================== */
(function () {
  if (window.__mifSwatch) return;
  window.__mifSwatch = true;

  var SIZE_PARAM = '&width=533'; // must match assets/product-card-swatch.js
  var MAX_PARALLEL = 4;
  var queue = [];
  var inFlight = 0;
  var seen = {}; // preloaded URLs
  var chosen = new Set(); // cards where a swatch was clicked
  var timer = null;

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function pump() {
    while (inFlight < MAX_PARALLEL && queue.length) {
      var url = queue.shift();
      inFlight++;
      var img = new Image();
      img.decoding = 'async';
      if ('fetchPriority' in img) img.fetchPriority = 'low';
      img.onload = img.onerror = function () {
        inFlight--;
        pump();
      };
      img.src = url;
    }
  }

  function enqueue(url, urgent) {
    if (seen[url]) return;
    seen[url] = true;
    if (urgent) queue.unshift(url);
    else queue.push(url);
    pump();
  }

  function mainImage(card) {
    return card.querySelector('.m-product-card__main-image img');
  }

  function prepare(card, urgent, tries) {
    if (card.__mifPrepared) return;
    var sw = card.querySelector('pcard-swatch');
    if (!sw) {
      card.__mifPrepared = true;
      return;
    }
    var data = sw.productData;
    if (!data || !data.variants) {
      // Minimog is still fetching /products/<handle>.js
      if ((tries || 0) < 20) {
        setTimeout(function () {
          prepare(card, urgent, (tries || 0) + 1);
        }, 400);
      }
      return;
    }
    card.__mifPrepared = true;
    data.variants.forEach(function (v) {
      var src = v && v.featured_image && v.featured_image.src;
      if (src && src.indexOf('?') > -1) enqueue(src + SIZE_PARAM, urgent);
    });
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            var run = function () { prepare(entry.target, false, 0); };
            if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 2000 });
            else setTimeout(run, 200);
          });
        },
        { rootMargin: '200px' }
      )
    : null;

  function watch(root) {
    if (!root || !root.querySelectorAll) return;
    var cards = root.matches && root.matches('.m-product-card') ? [root] : [];
    cards = cards.concat(Array.prototype.slice.call(root.querySelectorAll('.m-product-card')));
    cards.forEach(function (card) {
      if (card.__mifWatched) return;
      card.__mifWatched = true;
      if (io) io.observe(card);
      else prepare(card, false, 0);
    });
  }

  // Cards are also added later (filters, pagination, sliders, quick view)
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) watch(n);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener(
    'pointerover',
    function (e) {
      var card = e.target.closest && e.target.closest('.m-product-card');
      if (card) prepare(card, true, 0);
    },
    { passive: true }
  );

  // After a swatch click: Minimog has already set the new variant (it runs on
  // the label/select itself, before this document-level listener).
  function onSelect(e) {
    var t = e.target;
    var node = t.closest && t.closest('.m-product-option--node__label, .m-product-option--dropdown-select');
    if (!node) return;
    var sw = node.closest('pcard-swatch');
    var card = node.closest('.m-product-card');
    if (!sw || !card) return;
    var variant = sw.currentVariant;
    var src = variant && variant.featured_image && variant.featured_image.src;
    if (!src) return; // variant has no image: Minimog leaves the card as it is

    card.__mifSrc = src + SIZE_PARAM;
    chosen.add(card);

    var img = mainImage(card);
    if (!img || !img.animate || (reduceMotion && reduceMotion.matches)) return;
    var fade = function () {
      img.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, easing: 'ease' });
    };
    if (img.complete) fade();
    else img.addEventListener('load', fade, { once: true });
  }
  document.addEventListener('click', onSelect);
  document.addEventListener('change', onSelect);

  // Re-apply the chosen colour if Minimog's m:image-loaded reset overrides it
  function reapply() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      chosen.forEach(function (card) {
        if (!card.isConnected) {
          chosen.delete(card);
          return;
        }
        var img = mainImage(card);
        if (img && card.__mifSrc && img.getAttribute('src') !== card.__mifSrc) {
          img.src = card.__mifSrc;
          img.removeAttribute('srcset');
        }
      });
    }, 0);
  }

  function subscribe(tries) {
    var ev = window.MinimogEvents;
    if (ev && typeof ev.subscribe === 'function') {
      ev.subscribe('m:image-loaded', reapply);
    } else if (tries < 50) {
      setTimeout(function () { subscribe(tries + 1); }, 200);
    }
  }
  subscribe(0);

  watch(document.documentElement);
})();